import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";

import AdminLayout from "Layout/AdminLayout";
import AuthLayout from "Layout/AuthLayout";
import IsLogin from "Common/Globle/IsLogin";

import { Toaster } from "react-hot-toast";
import FrontendLayout from "Layout/FrontendLayout";
import Spinner from "Common/Globle/Spinner";

// Auth routes that bypass the IsLogin guard
const AUTH_ROUTES = new Set([
  "/admin/signin",
  "/admin/signup",
  "/admin/password-reset",
  "/admin/two-step",
  "/admin/lockscreen",
  "/admin/maintenance",
  "/admin/404",
]);

// Catches render errors anywhere in the tree and shows a fallback
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100 gap-3">
          <h5 className="text-danger">Something went wrong.</h5>
          <button
            className="btn btn-primary btn-sm"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const App = () => {
  const { pathname } = useLocation();

  const isAuthRoute = AUTH_ROUTES.has(pathname);
  const isAdminRoute = pathname.startsWith("/admin");

  return (
    <ErrorBoundary>
      <Suspense fallback={<Spinner />}>
        {isAuthRoute ? (
          <AuthLayout />
        ) : isAdminRoute ? (
          <IsLogin>
            <AdminLayout />
          </IsLogin>
        ) : (
          <FrontendLayout />
        )}
        <Toaster />
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
